import * as React from 'react';
import { GetServerSideProps } from 'next';
import {
    getGenericServerSideProps,
    PageProps,
} from 'server/page-props/get-generic-server-side-props';
import PageIndex from 'components/pages/page-index';
import PageNotFound from 'components/pages/page-not-found';

export const IndexPage: React.FC<PageProps> = ({
    guides,
    tools,
    helplines,
    updates,
    activeToolItemUrl,
    navigation,
    video,
    pageNotFound,
}) => {
    if (pageNotFound) {
        return <PageNotFound />;
    }

    return (
        <PageIndex
            tools={tools}
            guides={guides}
            helplines={helplines}
            updates={updates}
            activeToolItemUrl={activeToolItemUrl}
            navigation={navigation}
            video={video}
        />
    );
};

export default IndexPage;

export type { PageProps as IndexPageProps };

export const getServerSideProps: GetServerSideProps<PageProps> = getGenericServerSideProps;
